'use strict';

(function (window) {
    'use strict';

    var ORDERS_KEY = 'nextMovingMemberOrders';
    var SESSION_KEY = 'nextMovingMemberSession';
    var SEED_KEY = 'nextMovingMemberOrdersSeededV7';

    var STATUS_ACTIVE = 'Active';
    var STATUS_COMPLETED = 'Completed';
    var STATUS_CANCELLED = 'Cancelled';

    function normalizePhone(phone) {
        return String(phone || '').replace(/\D/g, '');
    }

    function formatPhone(phone) {
        var digits = normalizePhone(phone);

        if (digits.length === 10) {
            return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        }

        if (digits.length === 11 && digits.charAt(0) === '1') {
            return '(' + digits.slice(1, 4) + ') ' + digits.slice(4, 7) + '-' + digits.slice(7);
        }

        return phone || '';
    }

    function formatPrice(amount) {
        var num = Number(amount) || 0;
        if (num <= 0) {
            return '-';
        }
        return '$' + num.toFixed(0);
    }

    function formatDate(dateString) {
        if (!dateString) {
            return '-';
        }

        var str = String(dateString).trim();
        var date;

        if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            date = new Date(str + 'T12:00:00');
        } else {
            var isoStr = str.indexOf(' ') > -1 && str.indexOf('T') === -1 ? str.replace(' ', 'T') : str;
            date = new Date(isoStr);
        }

        if (isNaN(date.getTime())) {
            return dateString;
        }

        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var year = date.getFullYear();

        return month + '/' + day + '/' + year;
    }

    function formatPaymentDate(dateString) {
        if (!dateString) {
            return '-';
        }

        if (dateString.indexOf('T') > -1) {
            return formatDate(dateString.split('T')[0]);
        }

        return formatDate(dateString);
    }

    function formatPaymentType(payment) {
        if (!payment) {
            return '-';
        }

        var type = payment.paymentType || payment.label || '';
        switch (String(type).toLowerCase()) {
            case 'payment':
                return 'Payment';
            case 'deposit':
                return 'Deposit';
            case 'refund':
                return 'Refund';
            case 'tv_installation':
                return 'TV Installation';
            default:
                if (type) {
                    return String(type).replace(/_/g, ' ').replace(/\b\w/g, function (c) {
                        return c.toUpperCase();
                    });
                }
                return '-';
        }
    }

    function formatPaymentMethod(payment) {
        if (!payment || !payment.method) {
            return '-';
        }

        if (payment.method === 'cash') {
            return 'Cash';
        }

        if (payment.method === 'credit_card') {
            var last4 = payment.cardLast4 || '----';
            return 'Credit Card •••• ' + last4;
        }

        return payment.method;
    }

    function readJson(key, fallback) {
        try {
            var raw = typeof window.getCriticalData === 'function' ? window.getCriticalData(key) : localStorage.getItem(key);
            var value = JSON.parse(raw || 'null');
            return value === null ? fallback : value;
        } catch (error) {
            return fallback;
        }
    }

    function writeJson(key, value) {
        var str = JSON.stringify(value);
        if (typeof window.setCriticalData === 'function') {
            window.setCriticalData(key, str);
        } else {
            try {
                localStorage.setItem(key, str);
            } catch (e) {}
        }
    }

    function getOrders() {
        var allOrders = readJson(ORDERS_KEY, []);
        var session = getSession();
        if (!session || !session.phone) return [];
        var currentPhone = normalizePhone(session.phone);

        return allOrders.filter(function (order) {
            var custPhone = order.customer && order.customer.phone ? normalizePhone(order.customer.phone) : '';
            var leadPhone = order.lead && order.lead.phone ? normalizePhone(order.lead.phone) : '';
            return !custPhone || custPhone === currentPhone || leadPhone === currentPhone;
        });
    }

    function saveOrders(orders) {
        writeJson(ORDERS_KEY, orders);
    }

    function getOrderById(orderId) {
        if (!orderId) return null;
        return getOrders().find(function (order) {
            return String(order.id) === String(orderId) || String(order.leadId) === String(orderId) || String(order.quoteNumber) === String(orderId);
        }) || null;
    }

    function getOrdersForPhone(phone) {
        var normalized = normalizePhone(phone);

        return getOrders().filter(function (order) {
            return normalizePhone(order.customer && order.customer.phone) === normalized;
        }).sort(function (left, right) {
            return new Date(right.movingDate).getTime() - new Date(left.movingDate).getTime();
        });
    }

    function updateOrder(orderId, changes) {
        var orders = getOrders();
        var index = orders.findIndex(function (order) {
            return String(order.id) === String(orderId) || String(order.leadId) === String(orderId) || String(order.quoteNumber) === String(orderId);
        });

        if (index === -1) {
            var newOrder = Object.assign({ id: orderId }, changes, {
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            });
            orders.push(newOrder);
            saveOrders(orders);
            return newOrder;
        }

        orders[index] = Object.assign({}, orders[index], changes, {
            updatedAt: new Date().toISOString()
        });
        saveOrders(orders);

        return orders[index];
    }

    function cancelOrder(orderId) {
        var order = getOrderById(orderId);

        if (!order || order.status !== STATUS_ACTIVE) {
            return null;
        }

        return updateOrder(orderId, { status: STATUS_CANCELLED });
    }

    function addServiceToOrder(orderId, service) {
        var order = getOrderById(orderId);

        if (!order || order.status !== STATUS_ACTIVE) {
            return null;
        }

        var services = (order.services || []).slice();
        services.push(service);

        return updateOrder(orderId, { services: services });
    }

    function removeServiceFromOrder(orderId, serviceId) {
        var order = getOrderById(orderId);

        if (!order) {
            return null;
        }

        var st = String(order.status || '').toLowerCase();
        if (st === 'cancelled' || st === '3' || st === '0') {
            return null;
        }

        var services = (order.services || []).filter(function (service) {
            return String(service.id) !== String(serviceId);
        });

        return updateOrder(order.id || orderId, { services: services });
    }

    function getSession() {
        return readJson(SESSION_KEY, null);
    }

    function setSession(session) {
        var oldSession = getSession();
        if (oldSession && session && normalizePhone(oldSession.phone) !== normalizePhone(session.phone)) {
            clearOrders();
        }
        writeJson(SESSION_KEY, session);
    }

    function clearOrders() {
        if (typeof window.removeCriticalData === 'function') {
            window.removeCriticalData(ORDERS_KEY);
            window.removeCriticalData('nextMovingMemberOrders');
        }
        try {
            localStorage.removeItem(ORDERS_KEY);
            localStorage.removeItem('nextMovingMemberOrders');
            localStorage.removeItem('nextMovingMemberOrdersSeededV7');
        } catch (e) {}
    }

    function clearSession() {
        clearOrders();
        if (typeof window.removeCriticalData === 'function') {
            window.removeCriticalData(SESSION_KEY);
        }
        try {
            localStorage.removeItem(SESSION_KEY);
            sessionStorage.clear();
        } catch (e) {}
    }

    function login(phone, pin) {
        return {
            success: false,
            message: 'Local login is not available.'
        };
    }

    function logout() {
        clearSession();
    }

    function requireAuth(redirectUrl) {
        var session = getSession();

        if (!session || !session.phone) {
            window.location.href = redirectUrl || '/member-login';
            return null;
        }

        return session;
    }

    function statusClass(status) {
        if (status === STATUS_COMPLETED) {
            return 'is-completed';
        }

        if (status === STATUS_CANCELLED) {
            return 'is-cancelled';
        }

        return 'is-active';
    }

    function getTvInstallationPayment(order) {
        var tvService = (order.services || []).find(function (service) {
            return service.type === 'tv-installation';
        });

        if (!tvService) {
            return null;
        }

        return {
            id: 'payment-tv',
            paymentType: 'TV Installation',
            label: 'TV Installation',
            amount: 210,
            date: order.updatedAt ? order.updatedAt.split('T')[0] : order.movingDate,
            method: 'credit_card',
            cardLast4: '8912'
        };
    }

    function getOrderPayments(order) {
        if (!order) {
            return [];
        }

        if (order.payments && order.payments.length) {
            return order.payments;
        }

        var payments = [];
        var orderDate = (order.createdAt || order.updatedAt || '').split('T')[0] || order.movingDate;

        if (order.status === STATUS_ACTIVE) {
            payments.push({
                id: 'payment-deposit',
                paymentType: 'Deposit',
                label: 'Deposit',
                amount: 99,
                date: orderDate,
                method: 'credit_card',
                cardLast4: '4242'
            });
        } else if (order.depositPaid > 0) {
            payments.push({
                id: 'payment-deposit',
                paymentType: 'Deposit',
                label: 'Deposit',
                amount: order.depositPaid,
                date: orderDate,
                method: 'credit_card',
                cardLast4: '4242'
            });
        }

        var tvPayment = getTvInstallationPayment(order);

        if (tvPayment) {
            payments.push(tvPayment);
        }

        return payments;
    }

    function downloadPaymentReceipt(order, payment) {
        var targetPayment = payment || order;
        if (!targetPayment) {
            return;
        }

        var paymentId = targetPayment.id;
        if (!paymentId) {
            console.error('Payment ID is required to download receipt');
            return;
        }

        var quoteNumber = order && (order.quoteNumber || order.id) || 'receipt';
        var safeId = String(paymentId).replace(/[^a-zA-Z0-9-_]/g, '');
        var apiUrl = window.NEXT_MOVING_API_URL + '/payments/' + encodeURIComponent(paymentId) + '/receipt.pdf?download=true';

        var session = getSession();
        var headers = {};
        if (session && session.token) {
            headers['Authorization'] = 'Bearer ' + session.token;
        }

        fetch(apiUrl, {
            method: 'GET',
            headers: headers
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Failed to download receipt: ' + response.statusText);
            }
            return response.blob();
        }).then(function (blob) {
            var blobUrl = window.URL.createObjectURL(blob);
            var link = document.createElement('a');

            link.href = blobUrl;
            link.download = 'receipt-' + quoteNumber + '-' + safeId + '.pdf';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        }).catch(function (error) {
            console.warn('API fetch receipt failed, opening link directly:', error);
        });
    }

    function downloadBillOfLading(order) {
        if (!order) {
            return;
        }

        var quoteNumber = order.quoteNumber || order.id || 'order';
        var bolLines = ['Next Moving - Bill of Lading', '==============================', '', 'Order: ' + quoteNumber, 'Moving Date: ' + formatDate(order.movingDate), 'Status: ' + (order.status || '-'), '', 'Customer: ' + (order.customer && order.customer.name || '-'), 'Phone: ' + formatPhone(order.customer && order.customer.phone), '', 'Pickup:', order.fromAddress || '-', '', 'Delivery:', order.toAddress || '-', '', 'Property Type: ' + (order.propertyType || '-'), 'Property Size: ' + (order.propertySize || '-'), 'Fullness: ' + (order.fullness || '-'), 'Movers: ' + (order.movers || '-'), '', 'Special Instructions:', order.instructions || '-'];

        (order.services || []).forEach(function (service) {
            bolLines.push('');
            bolLines.push('Extra Service: ' + (service.label || '-'));
            bolLines.push('Details: ' + (service.summary || '-'));
            bolLines.push('Amount: ' + formatPrice(service.price));
        });

        bolLines.push('');
        bolLines.push('This is a prototype bill of lading document.');

        var blob = new Blob([bolLines.join('\n')], { type: 'text/plain;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');

        link.href = url;
        link.download = 'bill-of-lading-' + quoteNumber + '.txt';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    window.NextMovingMember = {
        ORDERS_KEY: ORDERS_KEY,
        SESSION_KEY: SESSION_KEY,
        STATUS_ACTIVE: STATUS_ACTIVE,
        STATUS_COMPLETED: STATUS_COMPLETED,
        STATUS_CANCELLED: STATUS_CANCELLED,
        normalizePhone: normalizePhone,
        formatPhone: formatPhone,
        formatPrice: formatPrice,
        formatDate: formatDate,
        formatPaymentDate: formatPaymentDate,
        formatPaymentType: formatPaymentType,
        formatPaymentMethod: formatPaymentMethod,
        getOrderPayments: getOrderPayments,
        downloadPaymentReceipt: downloadPaymentReceipt,
        downloadBillOfLading: downloadBillOfLading,
        getOrders: getOrders,
        getOrderById: getOrderById,
        getOrdersForPhone: getOrdersForPhone,
        updateOrder: updateOrder,
        cancelOrder: cancelOrder,
        addServiceToOrder: addServiceToOrder,
        removeServiceFromOrder: removeServiceFromOrder,
        getSession: getSession,
        login: login,
        logout: logout,
        requireAuth: requireAuth,
        statusClass: statusClass
    };
})(window);